export var TIMELINE_START = 'timebarstartplay';
export var TIMELINE_END = 'timebarendplay';
export var VALUE_CHANGE = 'valuechange';
export var TIMEBAR_CONFIG_CHANGE = 'timebarConfigChanged';
export var PLAY_PAUSE_BTN = 'playPauseBtn';
export var NEXT_STEP_BTN = 'nextStepBtn';
export var PRE_STEP_BTN = 'preStepBtn';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-plugin/es/timeBar/constant.js
// module id = null
// module chunks = 